import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { useSelector } from 'react-redux';
import { getAvailableFacilities } from 'store/search/searchSelectors';
import { getQueryFacilities } from 'store/router/routerSelectors';
import MultiSelectFilter from 'components/Filters/MultiSelectFilter';

const FacilityFilter = ({ onChange, hideCount, displayClearFilter, onClearFilter }) => {
  const availableFacilities = useSelector(getAvailableFacilities);
  const selectedFacilities = useSelector(getQueryFacilities);

  return (
    <MultiSelectFilter
      title="Facilities"
      filterKey="facilities"
      availableItems={availableFacilities}
      selectedItems={selectedFacilities}
      onChange={onChange}
      hideCount={hideCount}
      displayClearFilter={displayClearFilter}
      onClearFilter={onClearFilter}
      data-testid="facility-filter"
    />
  );
};

FacilityFilter.propTypes = {
  onChange: PropTypes.func,
  hideCount: PropTypes.bool,
  displayClearFilter: PropTypes.bool,
  onClearFilter: PropTypes.func,
};

FacilityFilter.defaultProps = {
  onChange: noop,
  hideCount: false,
  displayClearFilter: false,
  onClearFilter: () => {},
};

export default FacilityFilter;
